import { render, staticRenderFns } from "./RoomShow.vue?vue&type=template&id=614a15a3&scoped=true"
import script from "./RoomShow.vue?vue&type=script&lang=js"
export * from "./RoomShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614a15a3",
  null
  
)

export default component.exports